import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const WalletDepositIllustration = (props: SVGProps) => {
  const {
    title = 'WalletDepositIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 158 122"
      fill="none"
      {...restProps}
      className={cn('text-color-ref-primary-primary-50', className)}
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_2823_986)">
        <path
          fill="currentColor"
          d="M14.864 25.429C3.814 25.17.872 31.21.14 35.238c1.763 4.61 6.231 7.895 11.453 7.895h61.493v2.156H11.594A14.38 14.38 0 0 1 1.02 40.656c.39.662.881 1.275 1.468 1.809a19.7 19.7 0 0 0 2.784 2.113c.302.2 3.473 2.201 8.721 2.201H85.36V25.426H14.864z"
        />
        <path
          fill="#fff"
          d="M73.083 44.624v.665H11.594c-4.747 0-8.963-2.306-11.594-5.858v65.794c0 7.516 5.763 13.645 13.118 13.956q.423.02.861.02H95.59V44.627H73.083z"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          fill="none"
          d="M152.001 37.801c0-12.22-9.903-22.127-22.127-22.127s-22.126 9.907-22.126 22.127v5.304c0 12.22 9.91 22.13 22.126 22.13 12.224 0 22.127-9.907 22.127-22.13z"
        />
        <path
          fill="#fff"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M152.001 45.287c0 12.22-9.903 22.13-22.127 22.13-12.216 0-22.126-9.907-22.126-22.13 0-12.22 9.91-22.127 22.126-22.127s22.127 9.907 22.127 22.127Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M129.878 27.666c-9.737 0-17.629 7.888-17.629 17.622s7.892 17.622 17.629 17.622c9.736 0 17.622-7.889 17.622-17.622s-7.895-17.622-17.622-17.622Z"
        />
        <path
          fill="currentColor"
          d="M129.875 94.83c-12.338 0-22.379-10.04-22.379-22.378v-5.563c0-12.338 10.038-22.38 22.379-22.38s22.379 10.039 22.379 22.38v5.563c0 12.34-10.038 22.379-22.379 22.379"
        />
        <path
          fill="currentColor"
          d="M129.875 45.333c11.889 0 21.56 9.671 21.56 21.56v5.563c0 11.89-9.671 21.56-21.56 21.56s-21.56-9.67-21.56-21.56v-5.563c0-11.889 9.671-21.56 21.56-21.56m0-1.638c-12.806 0-23.198 10.389-23.198 23.198v5.563c0 12.813 10.388 23.198 23.198 23.198 12.809 0 23.198-10.388 23.198-23.198v-5.563c0-12.81-10.382-23.198-23.198-23.198"
        />
        <path
          fill="#000"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M152.001 72.325c0 12.22-9.903 22.13-22.127 22.13-12.216 0-22.126-9.907-22.126-22.13 0-12.22 9.91-22.127 22.126-22.127s22.127 9.907 22.127 22.127Z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M129.878 55.824c-9.117 0-16.508 7.388-16.508 16.502s7.391 16.502 16.508 16.502c9.111 0 16.502-7.388 16.502-16.502s-7.391-16.502-16.502-16.502Z"
        />
        <path
          fill="#fff"
          d="M130.52 120.21c-11.748 0-21.308-9.559-21.308-21.31v-5.305c0-11.748 9.56-21.307 21.308-21.307s21.308 9.56 21.308 21.307V98.9c0 11.752-9.56 21.311-21.308 21.311"
        />
        <path
          fill="#fff"
          d="M130.52 73.105c11.296 0 20.489 9.193 20.489 20.49v5.303c0 11.299-9.193 20.492-20.489 20.492s-20.489-9.193-20.489-20.492v-5.304c0-11.296 9.193-20.489 20.489-20.489m0-1.638c-12.217 0-22.127 9.907-22.127 22.127v5.304c0 12.22 9.91 22.13 22.127 22.13s22.127-9.907 22.127-22.13v-5.304c0-12.22-9.904-22.127-22.127-22.127"
        />
        <path
          fill="currentColor"
          d="M152.647 98.896c0 12.22-9.904 22.13-22.127 22.13-12.217 0-22.127-9.907-22.127-22.13 0-12.22 9.91-22.127 22.127-22.127s22.127 9.907 22.127 22.127"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M130.523 81.275c-9.736 0-17.628 7.889-17.628 17.622s7.892 17.622 17.628 17.622c9.727 0 17.622-7.889 17.622-17.622s-7.895-17.622-17.622-17.622Z"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          fill="none"
          d="M109.68 15.024S85.82-9.223 58.52 16.808"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          fill="none"
          d="m58.812 6.547-1.278 10.918 10.547.807"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="m157.413 6.304-7.715 7.898M143.051 11.439 144.889.133"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M0 81.46h33.492"
        />
        <path
          fill="#000"
          d="M33.4 83.305a1.848 1.848 0 1 0 0-3.696 1.848 1.848 0 0 0 0 3.696"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M0 91.317h34.507V108"
        />
        <path
          fill="#000"
          d="M32.66 107.905a1.85 1.85 0 0 0 1.847 1.848 1.85 1.85 0 0 0 1.848-1.848 1.85 1.85 0 0 0-1.848-1.847 1.85 1.85 0 0 0-1.848 1.847"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M0 71.595h34.507V54.917"
        />
        <path
          fill="#000"
          d="M36.355 55.008a1.85 1.85 0 0 0-1.848-1.848 1.85 1.85 0 0 0-1.848 1.848 1.85 1.85 0 0 0 1.848 1.848 1.85 1.85 0 0 0 1.848-1.848"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M65.663 98.117c9.132 0 16.534-7.403 16.534-16.535 0-9.131-7.402-16.534-16.534-16.534S49.128 72.45 49.128 81.582s7.403 16.535 16.535 16.535Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M73.912 81.679H57.591M65.752 73.773v15.814"
        />
        <path
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.638"
          d="M95.662 103.247v15.951H64.418"
        />
      </g>
      <defs>
        <clipPath id="clip0_2823_986">
          <path fill="#fff" d="M0 0h158v121.026H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

WalletDepositIllustration.displayName = 'WalletDepositIllustration';
